export const copy = (variable: any) => JSON.parse(JSON.stringify(variable));
